/**
 * @generated SignedSource<<f5a55b2db0d39bf05e1c7d776024275e>>
 * @relayHash c58b78e997cd2d1bf926e8e2e8d669a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraCascadingSelectOptionType = "ALL" | "CHILD" | "PARENT" | "%future added value";
export type useCascadingSelectValuesLoaderQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  jqlContext?: string | null | undefined;
  jqlTerm: string;
  optionType: JiraCascadingSelectOptionType;
  parentOptionId?: string | null | undefined;
  searchString?: string | null | undefined;
};
export type useCascadingSelectValuesLoaderQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly cascadingSelectValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly optionId: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      };
    };
  };
};
export type useCascadingSelectValuesLoaderQuery = {
  response: useCascadingSelectValuesLoaderQuery$data;
  variables: useCascadingSelectValuesLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlContext"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "optionType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentOptionId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "optionType",
        "variableName": "optionType"
      },
      {
        "kind": "Variable",
        "name": "parentOptionId",
        "variableName": "parentOptionId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jqlContext"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  }
],
v9 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v11 = {
  "kind": "ScalarField",
  "name": "optionId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCascadingSelectValuesLoaderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "args": (v8/*: any*/),
                      "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "cascadingSelectValues",
                      "plural": false,
                      "selections": [
                        (v9/*: any*/),
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraJqlCascadingOptionFieldValue",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v10/*: any*/),
                                    {
                                      "kind": "RequiredField",
                                      "field": (v11/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jqlBuilder.cascadingSelectValues.edges.node.optionId"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.jqlBuilder.cascadingSelectValues.edges.node"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.jqlBuilder.cascadingSelectValues.edges"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jqlBuilder.cascadingSelectValues"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jqlBuilder"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCascadingSelectValuesLoaderQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                "kind": "LinkedField",
                "name": "cascadingSelectValues",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d",
    "metadata": {},
    "name": "useCascadingSelectValuesLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "deb7ed0e1bb076edffe453408ba24625";

export default node;
